import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createBlock(_component_IconBase, {
    "view-box": "0 0 32 32",
    width: _ctx.iconSize,
    height: _ctx.iconSize,
    "icon-color": "transparent"
  }, {
    default: _withCtx(() => [
      (_ctx.category)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent('IconItemCategory' + _ctx.category), {
            key: 0,
            "icon-color": _ctx.internalIconColor
          }, null, 8, ["icon-color"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["width", "height"]))
}